import { render, staticRenderFns } from "./configProducts.vue?vue&type=template&id=1711295c&scoped=true"
import script from "./configProducts.vue?vue&type=script&lang=js"
export * from "./configProducts.vue?vue&type=script&lang=js"
import style0 from "./configProducts.vue?vue&type=style&index=0&id=1711295c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1711295c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1711295c')) {
      api.createRecord('1711295c', component.options)
    } else {
      api.reload('1711295c', component.options)
    }
    module.hot.accept("./configProducts.vue?vue&type=template&id=1711295c&scoped=true", function () {
      api.rerender('1711295c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/banquet_management/banquet_gd_details/form/components/configProducts.vue"
export default component.exports